<template lang="pug">
v-menu(
  offset-y,
  top,
  :left="variant === 'icon'",
  origin="top center",
  :min-width="148"
  open-on-hover
)
  template(v-slot:activator="{ on, attrs }")
    v-tooltip(top :disabled="!disabled")
      template(v-slot:activator="{ on: tooltipOn }")
        .suus__reactions(style="min-width: 40px" v-on="tooltipOn")
          ReactionIconButton(
            v-if="variant === 'icon'",
            :selected="selectedOption",
            v-bind="attrs",
            v-on="on"
            :disabled="disabled"
          )
          ReactionTextButton(
            v-else,
            :selected="selectedOption",
            v-bind="attrs",
            v-on="on"
            :disabled="disabled"
            @click="() => selectReaction(selectedOption.name)"
          )
      | Nur Gruppenmitglieder können auf Beiträge reagieren.
  v-list.pa-0.ma-0
    v-btn-toggle(
      :value="selectedOptionIndex",
      color="textColor",
      borderless,
      group
    )
      template(v-for="(option, index) in options")
        v-btn.ma-0(
          :key="option.name",
          v-if="option.name !== 'default'",
          @click="() => selectReaction(option.name)"
        )
          v-icon(:size="option.size", color="textColor") {{ option.icon }}
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "vue"
import { Emoji } from "suus-api"
import { EmojiOptionName } from "../../interfaces/emojiOptionName.type"
import useReactionOptions from "../../concerns/useReactionOptions"
import ReactionIconButton from "./ReactionIconButton.vue"
import ReactionTextButton from "./ReactionTextButton.vue"

export default defineComponent({
  name: "ReactionButton",
  props: {
    selectedReaction: {
      type: String as PropType<Emoji>,
      required: false,
      default: undefined,
    },
    variant: {
      type: String,
      validator: (val: string) => ["icon", "text"].includes(val),
      default: "text",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: { ReactionIconButton, ReactionTextButton },
  setup(props, context) {
    const { selectedOption, selectedOptionIndex, options, selectReaction } =
      useReactionOptions({
        source: computed(() => props.selectedReaction),
        createReaction: (newReaction: EmojiOptionName) => {
          context.emit("create-reaction", newReaction)
        },
        deleteReaction: (prevReaction: EmojiOptionName) => {
          context.emit("delete-reaction", prevReaction)
        },
        updateReaction: (
          prevReaction: EmojiOptionName,
          newReaction: EmojiOptionName
        ) => {
          context.emit("update-reaction", { prevReaction, newReaction })
        },
      })

    return {
      options,
      selectedOptionIndex,
      selectReaction,
      selectedOption,
    }
  },
})
</script>
